import { observer } from "mobx-react-lite";
import { FC } from "react";

import { useViewModel } from "@/hooks/use-view-model";
import { useGlobalStore } from "@/stores";
import { SweepstakeOperationType } from "@/types";

import { FormState } from "./FormState";
import { FormView } from "./FormView";

export type Props = {
  playerId: number;
  operationType: SweepstakeOperationType;
};

export const Form: FC<Props> = observer((props) => {
  const { eventBusService, intlService, userStore } = useGlobalStore();
  const state = useViewModel(
    () => new FormState(eventBusService, intlService, userStore),
    props,
  );
  return <FormView state={state} />;
});
